module.exports = __webpack_public_path__ + "img/logo.fe148749.png";